// src/Firebase.js
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// Your Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyA7j-sKr-oWhSCyQ9R1AN8vDa6ThVKagsE",
  authDomain: "zhufuagency.firebaseapp.com",
  projectId: "zhufuagency",
  databaseURL: "https://zhufuagency-2d392-default-rtdb.firebaseio.com", // ✅ must point to root
  storageBucket: "zhufuagency.appspot.com",
  messagingSenderId: "124150953879",
  appId: "1:124150953879:web:55a2a0f949039c19f3b6d2",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Realtime Database
export const db = getDatabase(app);

// Export the app as well
export { app };
